import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../config";

const backIcon = require("../assets/images/Arrow_Left.png");

const PageBackButton = ({ label, handleClick }) => {
  return (
    <Wrapper>
      <ImgWrapper src={backIcon} alt="back_icon" onClick={handleClick} />
      <TextFont fontColor={Colors.white} fontSize="1.375rem" fontWeight="700">
        {label}
      </TextFont>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: 1.68rem;
  width: fit-content;
  align-items: center;
`;

const ImgWrapper = styled.img`
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;

export default PageBackButton;
